import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useIsAuthenticated, useSignOut } from "react-auth-kit";

/**
 * Custom RequireAuth that avoids the react-auth-kit v2 bug where
 * dispatch(signOut) is called during render, triggering:
 * "Cannot update a component while rendering a different component"
 */
export const RequireAuth = ({
  children,
  loginPath,
}: {
  children: JSX.Element;
  loginPath: string;
}) => {
  const isAuthenticated = useIsAuthenticated();
  const signOut = useSignOut();
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    const authenticated = isAuthenticated();
    if (!authenticated) {
      signOut();
    }
    setAuthed(authenticated);
    setChecked(true);
  }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!checked) {
    return null;
  }

  if (!authed) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return children;
};
